import { createFileRoute } from '@tanstack/react-router';
import { WhatsAppSettingsRouteView } from '@/pages/workspaces/settings/actions/whatsapp/whatsapp-settings-route-view';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/whatsapp')({
  component: WhatsAppSettingsRouteView,
});
